/* eslint-disable import/no-cycle */

/* AUTH */
export const SIGN_IN_WITH_EMAIL = 'SIGN_IN_WITH_EMAIL';
export const SIGN_IN_WITH_EMAIL_SUCCESS = 'SIGN_IN_WITH_EMAIL_SUCCESS';
export const SIGN_IN_WITH_EMAIL_ERROR = 'SIGN_IN_WITH_EMAIL_ERROR';
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_ERROR = 'FORGOT_PASSWORD_ERROR';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR';

/* CONFIG */
export const CHANGE_MODE = 'CHANGE_MODE';
export const CHANGE_CHART = 'CHANGE_CHART';

/* ME */
export const GET_PROFILE = 'GET_PROFILE';
export const GET_PROFILE_SUCCESS = 'GET_PROFILE_SUCCESS';
export const GET_PROFILE_ERROR = 'GET_PROFILE_ERROR';
export const ME_LOGOUT = 'ME_LOGOUT';
export const ME_LOGOUT_SUCCESS = 'ME_LOGOUT_SUCCESS';
export const ME_LOGOUT_ERROR = 'ME_LOGOUT_ERROR';

/* USER */
export const USER_GET_LIST = 'USER_GET_LIST';
export const USER_GET_LIST_SUCCESS = 'USER_GET_LIST_SUCCESS';
export const USER_GET_LIST_ERROR = 'USER_GET_LIST_ERROR';
export const USER_CREATE = 'USER_CREATE';
export const USER_CREATE_SUCCESS = 'USER_CREATE_SUCCESS';
export const USER_CREATE_ERROR = 'USER_CREATE_ERROR';
export const USER_GET_DETAIL = 'USER_GET_DETAIL';
export const USER_GET_DETAIL_SUCCESS = 'USER_GET_DETAIL_SUCCESS';
export const USER_GET_DETAIL_ERROR = 'USER_GET_DETAIL_ERROR';
export const USER_UPDATE = 'USER_UPDATE';
export const USER_UPDATE_SUCCESS = 'USER_UPDATE_SUCCESS';
export const USER_UPDATE_ERROR = 'USER_UPDATE_ERROR';

/* EMOTION */
export const EMOTION_GET_NEWEST = 'EMOTION_GET_NEWEST';
export const EMOTION_GET_NEWEST_SUCCESS = 'EMOTION_GET_NEWEST_SUCCESS';
export const EMOTION_GET_NEWEST_ERROR = 'EMOTION_GET_NEWEST_ERROR';
export const EMOTION_GET_DETAILS = 'EMOTION_GET_DETAILS';
export const EMOTION_GET_DETAILS_SUCCESS = 'EMOTION_GET_DETAILS_SUCCESS';
export const EMOTION_GET_DETAILS_ERROR = 'EMOTION_GET_DETAILS_ERROR';

/* UPLOADER */
export const DEPARTMENT_GET_LIST = 'DEPARTMENT_GET_LIST';
export const DEPARTMENT_GET_LIST_SUCCESS = 'DEPARTMENT_GET_LIST_SUCCESS';
export const DEPARTMENT_GET_LIST_ERROR = 'DEPARTMENT_GET_LIST_ERROR';
export const POSITION_GET_LIST = 'POSITION_GET_LIST';
export const POSITION_GET_LIST_SUCCESS = 'POSITION_GET_LIST_SUCCESS';
export const POSITION_GET_LIST_ERROR = 'POSITION_GET_LIST_ERROR';

export * from './auth/actions';
export * from './me/actions';
export * from './user/actions';
export * from './emotion/actions';
export * from './uploader/actions';
export * from './config/actions';